import { EnvConfig } from './env-config.interface';
import { commitHash } from '../version';

export const environmentBase: EnvConfig = {
  // Sample API url
  API: 'https://demo.com',
  AUTH_TOKEN: 'token',
  DEFAULT_ITEMS_PER_PAGE: 25,
  VALIDATION_TYPES: ['pies65', 'pies67', 'pies70', 'pies71', 'pies72'],
  PENDO_ANLYTICS_ID: '3c993b18-47ab-4e88-7ffa-c389bea96403',
  DEFAULT_KIT_IMAGE: '/assets/svg/part-default-thumbnail.svg',
  DEFAULT_SUPPORT_URL: 'https://semadata.atlassian.net/helpcenter/PartsHub/',
  // ROLLBAR_KEY: 'ca037e0e70ac468dbf4706fc945a18ec',
  VERSION: commitHash,
  BUGSNAG_KEY: '',
  PUSHER_KEY: '205f31c940152a527479',
  JIRA_ID: 'db847139-cd2a-3b9b-be9f-d0cd57ed5e23',    // test
};
